import {
    GET_PROJECT_JOBS,
    GET_PROJECT_JOB,
    CREATE_PROJECT_JOB,
    UPDATE_PROJECT_JOB,
    UPDATE_PROJECT_JOB_RESULT,
    UPDATE_PROJECT_JOB_STATUS,
    REMOVE_PROJECT_JOBS
} from '../actions/types';

const INIT_STATE = {
    data_list: [],
    currentData: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

const replaceItem = (items, updatedItem) => items.map(item => (
    Number(item.id) === Number(updatedItem.id) ? { ...item, ...updatedItem } : item
));

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PROJECT_JOBS:
            return {
                ...state,
                data_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 30, 10)
                }
            };
        case GET_PROJECT_JOB:
            return { ...state, currentData: action.payload };
        case CREATE_PROJECT_JOB:
            return {
                ...state,
                data_list: [action.payload, ...state.data_list],
                pagination: { ...state.pagination, total: state.pagination.total + 1 }
            };
        case UPDATE_PROJECT_JOB:
        case UPDATE_PROJECT_JOB_RESULT:
        case UPDATE_PROJECT_JOB_STATUS:
            return {
                ...state,
                data_list: replaceItem(state.data_list, action.payload),
                currentData: state.currentData && Number(state.currentData.id) === Number(action.payload.id)
                    ? { ...state.currentData, ...action.payload }
                    : state.currentData
            };
        case REMOVE_PROJECT_JOBS: {
            const dataList = state.data_list.filter(item => !action.payload.includes(item.id));
            return {
                ...state,
                data_list: dataList,
                pagination: {
                    ...state.pagination,
                    total: Math.max(0, state.pagination.total - action.payload.length)
                }
            };
        }
        default:
            return state;
    }
};
